import * as $ from 'jquery';
import 'slick-carousel';

const imageCarousel = (selector: string) => {
	$(function () {
		$(selector).parent().addClass('hasSlick');
		$(selector).slick({
			arrows: false
			, autoplay: true
			, autoplaySpeed: 3000
			, dots: true
			, draggable: false
			, infinite: true
			, mobileFirst: true
			, nextArrow: '<button type="button" class="slick-control slick-next" title="Next"><span>Next</span> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.4 22" height="22" width="12.4"><title>Next</title><path d="M1.4 0l11 11-11 11L0 20.6 9.6 11 0 1.4z"> </path></svg></button>'
			, pauseOnHover: true
			, prevArrow: '<button type="button" class="slick-control slick-prev" title="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.4 22" height="22" width="12.4"><title>Previous</title><path d="M11 22L0 11 11 0l1.4 1.4L2.8 11l9.6 9.6z"> </path></svg> <span>Previous</span></button>'
			, responsive: [
				{ breakpoint: 950, settings: { slidesToShow: 3, slidesToScroll: 1 } },
				{ breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 1 } }
			]
			, rows: 0 // Fix vor v1.8.0-1
			, speed: 450
			, slidesToShow: 1
			, slidesToScroll: 1
			, useTransform: false
		});
	});

};

export default imageCarousel;
